export enum GenAddressType {
    DROP_SHIP = 'DROP_SHIP',
    DEFAULT = 'DEFAULT',
    FREIGHT_FORWARDER = 'FREIGHT_FORWARDER',
    FLOOR_PLAN = 'FLOOR_PLAN'
}
